import { lazyWithPreload } from '@kk/shared/utils/async';
import SearchPage from './index';

const Search = lazyWithPreload(() => import('./Search/Search'));

export default {
  id: 'search-page',
  path: '/search/',
  element: <SearchPage />,
  children: [
    {
      id: 'search',
      index: true,
      element: <Search />,
    },
  ],
};
